import { Component, OnInit, Inject, forwardRef, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { ContractorSelectionActivity } from 'src/app/models/activities/contractor-selection-activity';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { ContractorService, ValidationService } from 'src/app/services';

import { SelectContractorData, SelectContractorDataEntity } from 'src/app/models/data-entities/select-contractor-data-entity';
import { SelectContractorDataEntityInputComponent } from '../../../data-entities/select-contractor-data-entity/select-contractor-data-entity-input/select-contractor-data-entity-input.component';
import { of, Subscription } from 'rxjs';
import { DataEntityInputComponent } from '../../../data-entities/data-entity-input/data-entity-input.component';

@Component({
    selector: 'wm-contractor-selection-activity-input',
    templateUrl: './contractor-selection-activity-input.component.html',
    styleUrls: ['./contractor-selection-activity-input.component.css'],
    standalone: false
})
export class ContractorSelectionActivityInputComponent extends ActivityView
  implements OnInit, OnDestroy, AfterViewInit {
  activity: ContractorSelectionActivity;
  dataEntity: SelectContractorDataEntity;
  templateCode: string = 'SELECT_CONTRACTOR';
  selectContractorSub: Subscription;

  @ViewChild('selectContractor') selectContractor: DataEntityInputComponent;

  constructor(
    @Inject(forwardRef(() => ContractorService))
    public _contractorSvc: ContractorService
  ) {
    super();
  }
  ngAfterViewInit(): void {
    if (this.selectContractor?.inputComponentRef?.instance) {
      this.selectContractorSub = (this.selectContractor.inputComponentRef.instance as SelectContractorDataEntityInputComponent).selected.subscribe((e) => {
        this.contractorSelected(e);
      });
    }
  }

  async persistChildComponent() {
    if (this.form.valid) {
      this.dataEntity = null;
    }

    return of();
  }

  ngOnDestroy(): void {
    if (this.form) {
      this.form.removeControl(this.templateCode);
    }

    if (this.selectContractorSub) {
      this.selectContractorSub.unsubscribe();
    }
  }

  ngOnInit(): void {
    const de = new SelectContractorDataEntity();

    de.templateCode = this.templateCode;
    de.canEditContractor = this.activity.canEditContractor;
    de.allowNotListedOption = this.activity.model.allowNotListedOption;
    de.contractorTypeIds = this.activity.contractorTypeIds;
    de.parentActivity = this.activity;
    de.isRequired = true;
    de.isVisible = true;
    de.showLabel = false;
    de.contractorTypeDetails = this.activity.contractorTypeDetails;
    de.availableRegistrations = this.activity.availableRegistrations;
    de.allowRegisterRenewOption = false;

    // clear these out on the activity so we don't have JSON issue on submit
    this.activity.contractorTypeDetails = null;
    this.activity.availableRegistrations = null;

    if (this.activity.model.contractorSelection) {
      de.inputData.notInList = this.activity.model.contractorSelection.notInList;
      de.inputData.selectedContractorBusinessName = this.activity.model.contractorSelection.selectedContractorBusinessName;
      de.inputData.selectedContractorId = this.activity.model.contractorSelection.selectedContractorId;
      de.inputData.selectedRegistrationId = this.activity.model.contractorSelection.selectedRegistrationId;
    }

    this.dataEntity = de;
  }

  contractorSelected(inputData: SelectContractorData) {
    this.activity.model.contractorSelection.notInList = inputData.notInList;
    this.activity.model.contractorSelection.selectedContractorBusinessName = inputData.selectedContractorBusinessName;
    this.activity.model.contractorSelection.selectedContractorId = inputData.selectedContractorId;
    this.activity.model.contractorSelection.selectedRegistrationId = inputData.selectedRegistrationId;
  }
}
